import { yupResolver } from '@hookform/resolvers/yup';
import PropTypes from 'prop-types';
import { useMemo } from 'react';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
// @mui
import LoadingButton from '@mui/lab/LoadingButton';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import MenuItem from '@mui/material/MenuItem';
// _mock
import { USER_STATUS_OPTIONS } from 'src/_mock';
// assets
import { countries } from 'src/assets/data';
// components
import { InputAdornment } from '@mui/material';
import { useGetTenants } from 'src/api/tenants';
import FormProvider, { RHFAutocomplete, RHFSelect, RHFTextField } from 'src/components/hook-form';
import Iconify from 'src/components/iconify';
import { useSnackbar } from 'src/components/snackbar';
import axiosInstance, { endpoints } from 'src/utils/axios';

// ----------------------------------------------------------------------
const TYPES_OF_TENANT = [
  { id: 'saas', label: 'SaaS' },
  { id: 'licensed', label: 'Enterprise License' },
];
export default function UserQuickEditForm({ currentUser, open, onClose }) {
  const { enqueueSnackbar } = useSnackbar();
  const { tenantsMutate } = useGetTenants();
  const NewUserSchema = Yup.object().shape({
    name: Yup.string().required('Name is required'),
    email: Yup.string().required('Email is required').email('Email must be a valid email address'),
    contactNumber: Yup.string().required('Phone number is required'),
    address: Yup.string().required('Address is required'),
    type: Yup.object()
      .shape({
        id: Yup.string(),
        label: Yup.string(),
      })
      .required('Type is required'),
    orgName: Yup.string().required('Organization name is required'),
    // country: Yup.string().required('Country is required'),
    // company: Yup.string().required('Company is required'),
    // state: Yup.string().required('State is required'),
    // city: Yup.string().required('City is required'),
    // role: Yup.string().required('Role is required'),
    // zipCode: Yup.string().required('Zip code is required'),
    // avatarUrl: Yup.mixed().nullable().required('Avatar is required'),
    // not required
    status: Yup.string().required('Status is required'),
    // isVerified: Yup.boolean(),
  });

  const defaultValues = useMemo(
    () => ({
      name: currentUser?.name || '',
      // city: currentUser?.city || '',
      // role: currentUser?.role || '',
      email: currentUser?.email || '',
      // state: currentUser?.state || '',
      status: currentUser?.status || '',
      address: currentUser?.address || '',
      type: TYPES_OF_TENANT.find((_ty) => _ty.id === currentUser?.type) || { label: '', id: '' },
      // country: currentUser?.country || '',
      // zipCode: currentUser?.zipCode || '',
      // company: currentUser?.company || '',
      // avatarUrl: currentUser?.avatarUrl || null,
      contactNumber: currentUser?.contactNumber || '',
      orgName: currentUser?.orgName || '',
      // isVerified: currentUser?.isVerified || true,
    }),
    [currentUser]
  );

  const methods = useForm({
    resolver: yupResolver(NewUserSchema),
    defaultValues,
  });

  const {
    reset,
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const onSubmit = handleSubmit(async (data) => {
    try {
      data.type = data.type.id;
      await axiosInstance.put(`${endpoints.tenants.update}${currentUser.id}`, data);
      reset();
      onClose();
      tenantsMutate();
      enqueueSnackbar('Update success!');
      console.info('DATA', data);
    } catch (error) {
      console.error(error);
    }
  });

  return (
    <Dialog
      fullWidth
      maxWidth={false}
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: { maxWidth: 720 },
      }}
    >
      <FormProvider methods={methods} onSubmit={onSubmit}>
        <DialogTitle>Quick Update</DialogTitle>

        <DialogContent>
          {/* <Alert variant="outlined" severity="info" sx={{ mb: 3 }}>
            Account is waiting for confirmation
          </Alert> */}

          <Box sx={{ mb: 3 }} />

          <Box
            rowGap={3}
            columnGap={2}
            display="grid"
            gridTemplateColumns={{
              xs: 'repeat(1, 1fr)',
              sm: 'repeat(2, 1fr)',
            }}
          >
            <RHFSelect name="status" label="Status">
              {[
                { value: 'active', label: 'Active' },
                { value: 'inactive', label: 'In Active' },
              ].map((status) => (
                <MenuItem key={status.value} value={status.value}>
                  {status.label}
                </MenuItem>
              ))}
            </RHFSelect>

            <Box sx={{ display: { xs: 'none', sm: 'block' } }} />

            <RHFTextField name="orgName" label="Organization Name" />
            <RHFTextField name="name" label="Full Name" />
            <RHFTextField name="email" label="Email Address" />
            <RHFTextField
              name="contactNumber"
              label="Phone Number"
              InputProps={{
                startAdornment: <InputAdornment position="start">+966</InputAdornment>,
              }}
            />
            <RHFTextField name="address" label="Address" />
            <RHFAutocomplete
              name="type"
              label="Type"
              options={TYPES_OF_TENANT}
              getOptionLabel={(option) => option.label}
              isOptionEqualToValue={(option, value) => option === value}
            />
          </Box>
        </DialogContent>

        <DialogActions>
          <Button variant="outlined" onClick={onClose}>
            Cancel
          </Button>

          <LoadingButton type="submit" variant="contained" loading={isSubmitting}>
            Update
          </LoadingButton>
        </DialogActions>
      </FormProvider>
    </Dialog>
  );
}

UserQuickEditForm.propTypes = {
  currentUser: PropTypes.object,
  onClose: PropTypes.func,
  open: PropTypes.bool,
};
